import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Input, ViewChild, AfterViewInit, OnDestroy, ViewChildren } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { DataSource } from '@angular/cdk/collections';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Subscription, BehaviorSubject, Observable, merge } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { Message } from 'src/app/core/class/message';
import { tap } from 'rxjs/operators';
import { ViewPdfComponent } from 'src/app/shared/components/view-pdf/view-pdf.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { CdkDetailRowDirective } from 'src/app/shared/directive/cdk-detail-row.directive';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { UpdateDocumentTypeComponent } from './update-document-type/update-document-type.component';
import { Router } from '@angular/router';
import { DocumentService } from 'src/app/core/services/document.service';
import { MatSelect } from '@angular/material';
import { AddDocumentTypeComponent } from './add-document-type-list/add-document-type/add-document-type.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ResponsiveService } from '../../../../../core/services/responsive.service';

export interface DocumentType {
  id: string;
  name: string;
  code: string;
  parentId: string;
  description: string;
  status: boolean;
  isAutoSign: boolean;
  isOtpSign: boolean;
  relationOtpSign: boolean;
  symbol: string;
}

@Component({
  selector: 'app-document-type',
  templateUrl: './document-type.component.html',
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DocumentTypeComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  show = false;
  constructor(
    private documentTypeService: DocumentTypeService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    private notifier: NotifierService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private documentService: DocumentService,
    private responsiveService: ResponsiveService
  ) {
    super(commonService, message);
    this.notifier = notifier;
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
  }
  // displayedColumns: string[] = [
  //   'STT',
  //   'name', // giữ lại tên mẫu tài liệu
  //   // 'parentId', // giữ lại thông tin mẫu tài liệu cha
  //   'description', // giữ lại mô tả
  //   'CTS',
  //   'isOtpSign', // giữ lại trạng thái
  //   'isAutoSign',
  //   'status',
  //   'symbol' // giữ lại tác động
  // ];

  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "STT", showMobile: true },
    { def: "name", showMobile: true },
    { def: "description", showMobile: false },
    { def: "CTS", showMobile: false },
    { def: "isOtpSign", showMobile: false },
    { def: "isAutoSign", showMobile: false },
    { def: "status", showMobile: true },
    { def: "action", showMobile: true },
  ];


  // displayedColumnsSecond: string[] = [
  //   'STTSecond',
  //   'nameSecond',
  //   'descriptionSecond',
  //   'sumSecond',
  //   'statusSecond',
  //   'symbolSecond'
  // ];

  displayedColumnsSecond: string[] = [];

  columnDefinitionsSecond = [
    { def: "STTSecond", showMobile: true },
    { def: "nameSecond", showMobile: true },
    { def: "descriptionSecond", showMobile: false },
    { def: "sumSecond", showMobile: false },
    { def: "statusSecond", showMobile: true },
    { def: "symbolSecond", showMobile: true }
  ];

  // displayedChildColumns: string[] = [
  //   'STT',
  //   'name', // giữ lại tên mẫu tài liệu
  //   // 'parentId', // giữ lại thông tin mẫu tài liệu cha
  //   'description', // giữ lại mô tả
  //   'CTS',
  //   'isOtpSign', // giữ lại trạng thái
  //   'isAutoSign',
  //   'status',
  //   'symbol' // giữ lại tác động
  // ];

  displayedColumnsChild: string[] = [];

  columnDefinitionsChild = [
    { def: "STT", showMobile: true },
    { def: "name", showMobile: true },
    { def: "description", showMobile: false },
    { def: "CTS", showMobile: false },
    { def: "isOtpSign", showMobile: false },
    { def: "isAutoSign", showMobile: false },
    { def: "status", showMobile: true },
    { def: "symbol", showMobile: true }
  ];

  documents = {
    nameOrCode: '',
    description: '',
    types: null,
    status: 'null',
    isAutoSign: null,
    isOtpSign: null,
    parentId: ''
  };

  checkFocus = true;
  dataSource: DocumentTypeDataSource;
  childDataSourceList: DocumentTypeDataSourceKeyPair = {};

  paginate: Paginate;
  childPaginateList: PaginateKeyPair = {};

  oldData = this.documents;
  childOldDataList: DocumentKeyPair = {};

  isFirstLoad = true;
  isTableLoading = false;
  childIsFirstLoadList: BooleanKeyPair = {};

  childIsExexpanding: Array<string>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  childSortList: SortKeyPair = {};

  sortDirection = 'ASC';
  childSortDirection: StringKeyPair = {};

  sortColumn = '';
  sortChildColumn: StringKeyPair = {};

  error = '';
  subscription: Subscription;
  expanded = [];
  openedRow: CdkDetailRowDirective;
  parentDocumentTypes: DocumentType[];
  @ViewChildren('focusInput') focusInput;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;

  @Input() singleChildRowDetail: boolean;


  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;


  ngOnInit() {
    this.dataSource = new DocumentTypeDataSource();
    this.loadData();
    window.scrollTo(0, 0);
    this.notificationService.subscribeErrorService();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
  }

  getDisplayedColumnsSecond() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumnsSecond = this.columnDefinitionsSecond
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumnsSecond = this.columnDefinitionsSecond.map(cd => cd.def);
    }
  }

  getDisplayedColumnsChild() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumnsChild = this.columnDefinitionsChild
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumnsChild = this.columnDefinitionsChild.map(cd => cd.def);
    }
  }

  // call api view file pdf
  viewHtml(id, name) {
    this.dialog.open(ViewPdfComponent, {
      width: '1000px',
      data: { id, isSystem: false, name },
    });
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    merge(this.sort.sortChange, page)
      .pipe(
        /* tap(() => this.loadData()) */
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
          this.getDisplayedColumnsSecond();
          this.getDisplayedColumnsChild();
        }
      }
    );
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  /**
   * Get search condition
   */
  getFilterCondition(page: number, pageSize: number, statusContain: any[], autoSignContain: any[], isOtpSignContain: any[],
    nameOrCodeContain: string = null, parentContainID: string = null): any {

    const filterCondition = {
      keyword: nameOrCodeContain,
      parentId: parentContainID,
      status: statusContain,
      isAutoSign: autoSignContain,
      isOtpSign: isOtpSignContain,
      page,
      pageSize,
    };

    let sortColumn = null;
    let sortDirection = null;

    if (parentContainID === null) {
      sortDirection = this.sortDirection;
      sortColumn = this.sortColumn; // is searching in parent
    } else {
      sortDirection = this.childSortDirection[parentContainID];
      sortColumn = this.sortChildColumn[parentContainID]; // is searching in child
    }

    let column = null;

    switch (sortColumn) {
      case 'name':
        column = {
          name: sortDirection
        };

        break;
      case 'code':
        column = {
          code: sortDirection
        };

        break;
      case 'parentId':
        column = {
          parentId: sortDirection
        };

        break;
      case 'description':
        column = {
          description: sortDirection
        };
        break;
    }

    filterCondition['sorts'] = column;

    return filterCondition;
  }

  /**
   * Change arrow icon
   */
  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Get data when init
   */
  loadData(page: number = 0, pageSize: number = 10) {
    // DESC or ASC
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.sortDirection = null;
      this.isFirstLoad = false;
    }

    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.setData([]);
    this.documentTypeService.searchDocumentType(this.getFilterCondition(page, pageSize,
      [true, false], [true, false], [true, false]))
      .subscribe(rs => {
        this.isTableLoading = false;
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }

        if (rs.data && rs.data.dataRow != null) {
          this.initParent(rs);
        }
      }, () => this.isTableLoading = false);
  }

  closeExpandCollapse(id) {
    document.getElementById("noSpanTable").click();
  }

  initParent(rs: any) {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    this.parentDocumentTypes = rs.data.dataRow;

    this.parentDocumentTypes.forEach(parent => {
      parent['STT'] = stt++;
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new Document();
      this.childSortList[parent.id] = new MatSort();
    });
    this.dataSource.setData(this.parentDocumentTypes);

    this.childIsExexpanding = [];
  }

  /**
   * Sort parent table
   */
  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortColumn = sort.active;
  }

  /**
   * Sort child table
   */
  sortChildData(sort: Sort, parentID: string) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortChildColumn[parentID] = sort.active;
    this.childSortList[parentID].direction = sort.direction;

    this.onFilterChildData(
      this.childPaginateList[parentID].currentPage,
      this.childPaginateList[parentID].pageSize, parentID);
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {

    const status: [] | any = this.oldData.status == null ||
      this.oldData.status === 'null' ? [false, true] : [(this.oldData.status)];
    const isAutoSign: [] | any = this.oldData.isAutoSign == null ||
      this.oldData.isAutoSign === 'null' ? [false, true] : [(this.oldData.isAutoSign)];
    const isOtpSign: [] | any = this.oldData.isOtpSign == null ||
      this.oldData.isOtpSign === 'null' ? [false, true] : [(this.oldData.isOtpSign)];

    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }

    } else {
      this.sortDirection = null;
      this.isFirstLoad = false;
    }

    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.setData([]);
    this.documentTypeService.searchDocumentType(
      this.getFilterCondition(page, pageSize, status, isAutoSign, isOtpSign, this.oldData.nameOrCode))
      .subscribe(
        rs => {
          this.isTableLoading = false;
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
          this.initParent(rs);
        }, () => this.isTableLoading = false
      );
  }

  /**
   * Load child data
   */
  onFilterChildData(page: number = 0, pageSize: number = 10, parentID: string) {

    if (this.childIsFirstLoadList[parentID] === false) {
      if (this.childSortList[parentID].direction === 'asc') {
        this.childSortDirection[parentID] = 'ASC';
      } else if (this.childSortList[parentID].direction === 'desc') {
        this.childSortDirection[parentID] = 'DESC';
      }

    } else {
      this.childIsFirstLoadList[parentID] = false;
    }

    this.documentTypeService.searchChildDocumentType(
      this.getFilterCondition(page, pageSize, [true, false], [true, false], [true, false],
        this.childOldDataList[parentID].nameOrCode, parentID))
      .subscribe(
        rs => {
          this.childPaginateList[parentID] = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
          this.initChild(rs, parentID);
        }
      );
  }

  initChild(rs: any, parentID: any) {
    let stt = this.childPaginateList[parentID].pageSize * this.childPaginateList[parentID].currentPage + 1;
    rs.data.dataRow.forEach(element => {
      element['STT'] = stt++;
      element.parentId = parentID;
    });

    this.childDataSourceList[parentID].setData(rs.data.dataRow);
  }

  /**
   * Open child table
   */
  expandedParent(parentID: string) {
    if (this.childIsExexpanding.includes(parentID)) {
      const index = this.childIsExexpanding.indexOf(parentID, 0);
      if (index > -1) {
        this.childIsExexpanding.splice(index, 1);
      }
      return;
    } else {
      this.childIsExexpanding.push(parentID);
    }
    this.childDataSourceList[parentID] = null;

    /* add child to parent to show  */
    this.parentDocumentTypes.forEach(parentDocumentType => {
      if (parentDocumentType.id === parentID) {
        this.documentTypeService.searchChildDocumentType(
          this.getFilterCondition(0, 10,
            this.oldData.status == null || this.oldData.status == 'null' ? [false, true] : [this.oldData.status],
            [false, true], [false, true],
            this.oldData.nameOrCode, parentID))
          .subscribe(rs => {
            if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
              && rs.data.totalRow != null && rs.data.totalRow != null) {
              this.childPaginateList[parentID] = {
                currentPage: rs.data.currentPage,
                pageSize: rs.data.pageSize,
                totalRow: rs.data.totalRow,
                totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
                totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
                no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
              };
            }
            if (rs.data && rs.data.dataRow != null) {
              this.show = true;
              this.childDataSourceList[parentID] = new DocumentTypeDataSource();
              this.initChild(rs, parentID);
            }
          });
      }
    });
  }

  /**
   * Change status
   */
  onChangeStatus(id: string, parentId: string, documentName: string, documentStatus: boolean) {
    // Them trang thai cua tai lieu vao warning
    var s1 = documentStatus ? '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_active') + '</strong>'
      : '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_inactive') + '</strong>';

    var s2 = !documentStatus ? '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_active') + '</strong>'
      : '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_inactive') + '</strong>';

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_change_status_document_type'),
        documentName, s1, s2)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentTypeService.changeStatusDocumentType(id).subscribe(() => {
          this.toastr.success(this.message.getMessage('messages.update_status_success'));
          // is parent element
          if (!parentId) {
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          } else {
            this.onFilterChildData(
              this.childPaginateList[parentId].currentPage,
              this.childPaginateList[parentId].pageSize, parentId);
          }
        });
        this.focusInput.first.nativeElement.focus();
      }
    });
  }

  getOtpSignStatus(doc: DocumentType): boolean {
    return doc.isOtpSign && doc.relationOtpSign;
  }

  /**
   * Set otp
   */
  onSetSignOTP(doc: DocumentType) {

    const signOTP = this.getOtpSignStatus(doc);
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage(signOTP
        ? 'messages.confirm_off_sign_otp' : 'messages.confirm_on_sign_otp'), doc.name)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentTypeService.setSignOTPDocumentType(doc.id).subscribe(() => {
          this.toastr.success(this.message.getMessage(!signOTP ? 'messages.on_sign_otp_sucess' : 'messages.off_sign_otp_sucess'));
          // is parent element
          if (!doc.parentId) {
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          } else {
            this.onFilterChildData(
              this.childPaginateList[doc.parentId].currentPage,
              this.childPaginateList[doc.parentId].pageSize, doc.parentId);
          }
        });
        this.focusInput.first.nativeElement.focus();
      }
    });
  }

  /**
   * Set otp
   */
  onSetAutoSign(id: string, isAutoSign: boolean, parentId: string, documentName: string) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage(isAutoSign
        ? 'messages.confirm_off_auto_sign' : 'messages.confirm_on_auto_sign'), documentName)

    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentTypeService.setAutoSignDocumentType(id).subscribe(() => {
          this.toastr.success(this.message.getMessage(
            isAutoSign ? 'messages.off_auto_sign_sucess' : 'messages.on_auto_sign_sucess'));
          // is parent element
          if (!parentId) {
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          } else {
            this.onFilterChildData(
              this.childPaginateList[parentId].currentPage,
              this.childPaginateList[parentId].pageSize, parentId);
          }

        });
      }
    });
  }

  /**
   * Open UpdateDocumentTypeComponent
   */
  openDialogUpdate(id: any) {
    const dialogRef = this.dialog.open(UpdateDocumentTypeComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '50%' : '30%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: { id }, disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
      this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
      this.focusInput.first.nativeElement.focus();
    });
  }
  /**
   * Open Add DocumentType
   */
  openDialogAdd() {
    const dialogRef = this.dialog.open(AddDocumentTypeComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '50%' : '30%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
    });
    dialogRef.afterClosed().subscribe(() => {
      this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
      this.focusInput.first.nativeElement.focus();
    });
  }

  /**
   * Search
   */
  onClickBtnFilter() {
    this.oldData = { ...this.documents };
  }

}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

export class Document {
  nameOrCode: string;
  description: string;
  types: any;
  status: any;
  isAutoSign: any;
  parentId: string;
}

export class SortKeyPair {
  /* @ViewChild(MatSort, { static: false }) sort: MatSort; */
  [key: string]: MatSort;
}

export class BooleanKeyPair {
  [key: string]: boolean;
}

export class StringKeyPair {
  [key: string]: string;
}

export class DocumentKeyPair {
  [key: string]: Document;
}

export class DocumentTypeDataSourceKeyPair {
  [key: string]: DocumentTypeDataSource;
}

export class PaginateKeyPair {
  [key: string]: Paginate;
}

export class DocumentTypeDataSource extends DataSource<DocumentType> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DocumentType[]>([]);

  constructor() {
    super();
  }


  setData(data: DocumentType[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DocumentType[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}
